<template>
    <div>
        <div class="d-flex justify-content-between">
            <h1 class="page-header">{{ $t('classAttendanceCheckList.pageTitle') }}</h1>
            <ts-breadcrumb :items="[
                { text: $t('toHomePage'), href: '/' },
                {
                    text: $t('classAttendanceCheckList.pageTitle'),
                    active: true
                }
            ]" />
        </div>
        <div class="row">
            <div class="col-md-3">
                <ts-card>
                    <ts-card-wrapper>
                        <ts-loading-banner :loading="loading">
                            <form>
                                <fieldset>
                                    <legend>{{ $t('classAttendanceCheckList.criteria') }}</legend>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label class="required">{{
                                                $t('classAttendanceCheckList.date')
                                                }}</label>
                                            <a-date-picker v-model="selectedMonth" format="MMM-YYYY"
                                                @change="onMonthChange" style="width: 100%" />
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label class="required">{{
                                                $t('classAttendanceCheckList.mainProgram')
                                                }}</label>
                                            <a-select style="width: 100%" v-model.number="model.acp_id"
                                                :options="main_programs" :show-search="true" :filter-option="(input, option) =>
                                                    option.componentOptions.children[0].text
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                    " @change="onChangeMainProgram"></a-select>
                                        </div>

                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label class="required">{{
                                                $t('classAttendanceCheckList.subProgram')
                                                }}</label>
                                            <a-select style="width: 100%" v-model.number="model.acps_id"
                                                :options="sub_programs" :show-search="true" :filter-option="(input, option) =>
                                                    option.componentOptions.children[0].text
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                    " @change="onSubChange" :disabled="!model.acp_id"
                                                :loading="fetching_acps"></a-select>
                                            <div class="validate" v-if="errors.has('acps_id')">
                                                {{ errors.first('acps_id') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label class="required">{{
                                                $t('classAttendanceCheckList.acYear')
                                                }}</label>
                                            <a-select style="width: 100%" v-model:value="model.ac_year_id"
                                                :options="ac_year_list" @change="acYearChange"
                                                :loading="fect_term"></a-select>
                                            <div class="validate" v-if="errors.has('ac_year_id')">
                                                {{ errors.first('ac_year_id') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label class="required">{{
                                                $t('classAttendanceCheckList.acTerm')
                                                }}</label>
                                            <a-select style="width: 100%" v-model.number="model.ac_term_id"
                                                :options="ac_terms" :show-search="true" :filter-option="(input, option) =>
                                                    option.componentOptions.children[0].text
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                    "></a-select>
                                            <div class="validate" v-if="errors.has('ac_term_id')">
                                                {{ errors.first('ac_term_id') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label>{{ $t('classAttendanceCheckList.studyTime') }}</label>
                                            <a-select style="width: 100%;" v-model="model.ac_st_id"
                                                :options="studyTimeOpt" :showSearch="true" :filterOption="(input, option) =>
                                                    option.componentOptions.children[0].text
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                    " @change="studyTimeChange"></a-select>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label class="required">{{
                                                $t('classAttendanceCheckList.teacher')
                                                }}</label>
                                            <a-select style="width: 100%" v-model="model.teacher_id" :options="teachers"
                                                showSearch :filterOption="(input, option) =>
                                                    option.componentOptions.children[0].text
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                    " @change="onChangeTeacher" :maxTagCount="1" :maxTagTextLength="17"
                                                :loading="fect_teacher">
                                            </a-select>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label>{{
                                                $t('classAttendanceCheckList.classOperation')
                                                }}</label>
                                            <a-select style="width: 100%" v-model="model.class_id"
                                                :options="class_options" :show-search="true"
                                                :loading="fetching_class_operation" :filter-option="(input, option) =>
                                                    option.componentOptions.children[0].text
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                    " :max-tag-count="5" :max-tag-text-length="50"></a-select>
                                            <div class="validate" v-if="errors.has('class_id')">
                                                {{ errors.first('class_id') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <label>{{
                                                $t('classAttendanceCheckList.studentNameOrder')
                                                }}</label>
                                            <a-select v-model="model.student_name" :options="sortDescAsc"
                                                class="ts-w-full"></a-select>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-md-6 text-right">
                                            <!-- <ts-button class="btn-block" outline color="success" @click.prevent="exportExcel"
												:waiting="exporting">{{
													$t('excel') }}</ts-button> -->
                                        </div>
                                        <div class="col-md-6 text-right">
                                            <ts-button class="btn-block" color="primary" @click.prevent="preview"
                                                :waiting="waiting">{{ $t('preview') }}</ts-button>
                                        </div>
                                    </div>

                                </fieldset>
                            </form>
                        </ts-loading-banner>
                    </ts-card-wrapper>
                </ts-card>
            </div>
            <div class="col-md-9">
                <ts-card>
                    <ts-card-wrapper>
                        <form>
                            <fieldset>
                                <legend>{{ $t('classAttendanceCheckList.preview') }}</legend>
                                <ts-preview-pdf v-model="waiting" :src="src" />
                            </fieldset>
                        </form>
                    </ts-card-wrapper>
                </ts-card>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
    name: 'reportClassAttendanceCheckList',
    data() {
        return {
            loading: false,
            waiting: false,
            exporting: false,
            fetch_sub: false,
            fetching_acps: false,
            fetching_class_operation: false,
            fect_teacher: false,
            fect_term: false,
            fectStudyTime: false,
            src: '',
            errors: new Errors(),
            sub_programs: [],
            ac_terms: [],
            ac_year_list: [],
            class_options: [],
            headers: [],
            columnLists: [],
            main_programs: [],
            teachers: [],
            selectedMonth: moment(),
            selected_ac_year: null,
            studyTimeOpt: [],
            model: {
                acps_id: null,
                ac_term_id: null,
                ac_year_id: null,
                class_id: null,
                acp_id: null,
                teacher_id: null,
                ac_st_id: null,
                student_name: 'asc',
                ac_status_id: null
            }
        }
    },
    created() {
        this.fetchData()
    },
    computed: {
        sortDescAsc() {
            return [
                { value: 'asc', label: 'Ascending' },
                { value: 'desc', label: 'Descending' },
            ]
        },
    },
    methods: {
        ...mapActions('reportClassAttendanceCheckList', [
            'classAttendance',
            'getSubProgram',
            'getTerm',
            'getYear',
            'getClassByTeacher',
            'getMainProgram',
            'getTeacher',
            'getStudyTimeOptions'
        ]),
        moment,
        async fetchData() {
            this.loading = true
            await this.getMainProgram()
                .then(response => {
                    this.main_programs = response.data.map(el => ({
                        value: el.acp_id,
                        label: el.acp_name_foreign
                    }))
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })

            await this.getStudyTimeOptions()
                .then(response => {
                    this.studyTimeOpt = response.data.map(el => ({
                        value: el.ac_st_id,
                        label: el.study_time
                    }))
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })

            await this.getYear()
                .then(response => {
                    this.ac_year_list = response.data.map(el => ({
                        value: el.ac_year_id,
                        label:
                            el.ac_year +
                            (el.ac_status_id === 1
                                ? ' ( Current )'
                                : el.ac_status_id === 2
                                    ? ' ( History )'
                                    : ' ( Next )')
                    }))
                    const current = response.data.find(el => el.ac_status_id === 1)
                    if (current) {
                        this.model.ac_year_id = current.ac_year_id
                    }
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        onChangeMainProgram(acp_id) {
            this.fetching_acps = true
            this.model.acps_id = null
            this.model.level_id = null
            this.model.grade_id = null
            this.getSubProgram({
                filter: {
                    acp_id: acp_id
                }
            })
                .then(response => {
                    this.sub_programs = response.data.map(el => ({
                        value: el.acps_id,
                        label: el.acps_name_foreign
                    }))
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.fetching_acps = false
                })
        },
        onSubChange(acps_id) {
            this.model.ac_term_id = null
            this.model.class_id = null
            this.fect_term = true
            this.getTerm({
                filter: {
                    acps_id: acps_id,
                    ac_year_id: this.model.ac_year_id
                }
            })
                .then(response => {
                    this.ac_terms = response.data.map(el => ({
                        value: el.ac_term_id,
                        label:
                            el.term_name +
                            (el.ac_status_id == 1
                                ? ' ( Current ) '
                                : el.ac_status_id == 2
                                    ? ' ( History ) '
                                    : ' ( Next ) ')
                    }))
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.fect_term = false
                })
        },
        acYearChange() {
            this.model.ac_term_id = null
            this.model.class_id = []
            this.getTerm({
                filter: {
                    ac_year_id: this.model.ac_year_id,
                    ac_status_id: this.model.ac_status_id,
                    acps_id: this.model.acps_id
                }
            })
                .then(response => {
                    this.ac_terms = response.data.map(el => ({
                        value: el.ac_term_id,
                        label:
                            el.term_name +
                            (el.ac_status_id == 1
                                ? ' ( Current ) '
                                : el.ac_status_id == 2
                                    ? ' ( History ) '
                                    : ' ( Next ) ')
                    }))
                })

                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.fect_term = false
                })
        },

        async onChangeTeacher() {
            this.model.class_id = null
            this.class_options = []
            this.fect_class = true

            try {
                if (!this.model.teacher_id) return

                const response = await this.getClassByTeacher({
                    teacher_id: this.model.teacher_id,
                    acp_id: this.model.acp_id,
                    acps_id: this.model.acps_id,
                    ac_term_id: this.model.ac_term_id,
                    ac_st_id: this.model.ac_st_id
                })

                const classes = Array.isArray(response.data) ? response.data : []

                this.class_options = classes.map(cls => ({
                    value: cls.class_id,
                    label: cls.class_name
                }))
            } catch (error) {
                this.$toasted.error(error.message)
                this.class_options = []
            } finally {
                this.fect_class = false
            }
        },
        onMonthChange(date) {
            if (!date) return;
            const monthName = date.format('MMM-YYYY');
            this.$store.commit(
                'reportClassAttendanceCheckList/SET_SELECTED_MONTH',
                date.format('MM-YYYY')
            );
        },

        async studyTimeChange() {
            this.model.teacher_id = null
            this.teachers = []
            this.fect_teacher = true

            try {
                const params = {
                    acp_id: this.model.acp_id,
                    acps_id: this.model.acps_id,
                    ac_term_id: this.model.ac_term_id,
                    ac_st_id: this.model.ac_st_id,
                    ac_year_id: this.model.ac_year_id
                }
                const response = await this.getTeacher(params)

                const teachers = response && Array.isArray(response.data) ? response.data : []

                this.teachers = teachers.map(el => ({
                    value: el.teacher_id,
                    label: `${el.fname_foreign} ${el.lname_foreign}`
                }))
            } catch (error) {
                this.$toasted.error(error.message)
                this.teachers = []
            } finally {
                this.fect_teacher = false
            }
        },
        preview() {
            this.waiting = true
            this.src = ''
            this.errors = new Errors()
            this.classAttendance(this.model)
                .then(response => {
                    this.src = response.url
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
                .finally(() => {
                    this.waiting = false
                })
        }
    }
}
</script>
